import React from 'react'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import TermSheetNavUI from '../../../components/superUser/loan/TermSheetNavUI'
import TermSheetSignSF from '../../../components/superUser/loan/document/TermSheetSignSF'

const TermSheetApprovalPageUI = ({ context, errorList, loan, onRefreshClick }) =>
  <SuperUserLoanPageUI context={context} className='pg_su_ts'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='termSheet'
    dimension='w1600'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Term sheet</b></span>
            </span>
          }
          right={<span />}
        />

        <TermSheetNavUI loan={loan} tab='approval' />
        <TermSheetSignSF context={context} loan={loan} onRefreshClick={onRefreshClick} />
      </div>
    }
  </SuperUserLoanPageUI>

export default TermSheetApprovalPageUI
